<template>
  <hr class="spacer"/>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
.spacer {
    @include margin(15px null);
    height: 1px;
    background-color: rgba($tertiary, .4);
    border: 0;
}
</style>
